import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import Signup from "./Auth/Signup";
import Facility from "./Dashboard/Facility";
import MyQueues from "./Dashboard/MyQueues";

import DefaultLayout from "./Layout/DefaultLayout";
function App(props) {
  return (
    <div className="App">
      <Router>
        <Switch>
        <Route path="/dashboard" component={(props) => {
                return (
                  <DefaultLayout {...props} >
                    <Facility {...props} />
                  </DefaultLayout>
                );
              }} />
              <Route path="/myQueues" component={(props) => {
                return (
                  <DefaultLayout {...props} >
                    <MyQueues {...props} />
                  </DefaultLayout>
                );
              }} />
          {/* <Route exact path="/report" component={Report} /> */}
          <Route exact path="/" component={Signup} />

        </Switch>
      </Router>
    </div>
  );
}

export default App;
